import myAxios from "@/utils/request";
export default {
  // 导师
  getList(params) {
    return myAxios.post("/api/expert/paging", params);
  },
  batchDelete(params) {
    return myAxios.post("/api/expert/batchdelete", params);
  },
  // 添加导师详情
  addTeacher(params) {
    return myAxios.post("/api/expert/add", {
      ...params
    });
  },
  // 修改导师详情
  modifyTeacher(params) {
    return myAxios.post("/api/expert/update", {
      ...params
    });
  },
  // 获取详细信息
  getInfo(params) {
    const { id } = params;
    return myAxios.get("/api/expert/info?id=" + id);
  },

  // 导师咨询
  getCounselList(params) {
    return myAxios.post("/api/expertconsult/paging", params);
  },
  batchDeleteCounsel(params) {
    return myAxios.post("/api/expertconsult/batchdelete", params);
  },
  // 获取导师咨询详情
  getCounselInfo(params) {
    const { id } = params;
    return myAxios.get("/api/expertconsult/info?id=" + id);
  },
  // 添加导师备注
  addCounselRemark(params) {
    return myAxios.post("/api/expertconsult/decadd", params);
  },
  // 导师备注详情
  getCounselRemarkInfo(params) {
    const { id } = params;
    return myAxios.get("/api/expertconsult/decinfo?consultId=" + id);
  },

  // 优质企业
  getCompanyList(params) {
    return myAxios.post("/api/company/paging", params);
  },
  batchDeleteCompany(params) {
    return myAxios.post("/api/company/batchdelete", params);
  },
  // 添加企业详情
  addCompany(params) {
    return myAxios.post("/api/company/add", {
      ...params
    });
  },
  // 修改企业详情
  modifyCompany(params) {
    return myAxios.post("/api/company/modify", {
      ...params
    });
  },
  getCompanyInfo(params) {
    const { id } = params;
    return myAxios.get("/api/company/companyinfo?id=" + id);
  }
};
